






















import timeline from '@/directives/timeline.coffee'

export default {
    name: 'GalleryItem'

    directives:
        timeline: timeline

    data: -> 
        filterTags: []
        fields: @defaultFields()

    computed:
        filter: -> 
            filter = ''
            @filterTags.map (tag) =>
                filter += '\?' + tag + ' '
            filter

    methods:
        defaultFields: ->
            image: [],
            title: [],
            subtitle: [],
            description: [],
            link: []
            categories: []

        setContent: (document) ->
            fields = 
                image: document.image
                title: document.title
                subtitle: document.subtitle
                description: document.description
                link: document.link
                categories: document.categories
            $.extend @fields, fields

            filterTags = @$prismic.richTextAsPlain @fields.categories
            filterTags = filterTags.split ','

            filterTags.map (tag) =>
                tag = tag.trim()
                if tag is '' then return null
                
                if @$parent.filterTags.indexOf(tag) < 0 
                    @$parent.filterTags.push tag
                
                if @filterTags.indexOf(tag) < 0
                    @filterTags.push tag

    mounted: ->
        $(@$el.parentNode).attr 'data-filter', @filter

    created: ->
        @setContent @$attrs.document
    
}
